import PropTypes from 'prop-types';
import { Svg } from '../common/Svg.js';

function TeacherStatsBanner({ isTeacher, teacherName }) {
    function renderTAWContent() {
        const blogUrl = 'https://blog.donorschoose.org/articles/teacher-appreciation-week-2024';

        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth();
        const currentDate = now.getDate();
        const currentHour = now.getUTCHours() - 4;

        // Month should be 4 (may), current date >=8 (monday) and <=13 (saturday), current year ===2024, below is for testing purposes
        // the dates here aren't needed since we have !isTeacher but placing here just as a precaution
        if (!isTeacher || !(currentMonth === 4 && currentDate >= 6 && currentDate <= 11 && currentYear === 2024)) {
            return null;
        }

        let tawCalendar = null;
        const tawHeader = (<h2>Happy Teacher Appreciation Week!</h2>);
        let tawWOD = null;
        let tawGAME = null;
        const tawSubHeader = null;
        const tawSubCopy = (
            <p className="">
                    Welcome to 5 days of thanks, joy, and tangible support for your classroom! Check back here each day for new content, games, and funding news.
                <br/><a className="button-secondary small" href={blogUrl} target="_blank" rel="noreferrer">Check out today&apos;s
                    funding</a>
            </p>
        );
        let tawContent = null;
        const tawSubheaderInterim = null;

        switch (currentDate) {
        // for monday 6th, 7am est
        case 6:
            if (currentHour >= 7) {
                tawCalendar = (
                    <div className="calendarContainer">
                        <div className="calendar">
                            <p className="day"> Monday </p>
                            <p className="number"> 6 </p>
                        </div>
                        <div className="calendar not-today">
                            <p className="day"> Tuesday </p>
                            <p className="number"> 7 </p>
                        </div>
                        <div className="calendar not-today">
                            <p className="day"> Wednesday </p>
                            <p className="number"> 8 </p>
                        </div>
                        <div className="calendar not-today">
                            <p className="day"> Thursday </p>
                            <p className="number"> 9 </p>
                        </div>
                        <div className="calendar not-today">
                            <p className="day"> Friday </p>
                            <p className="number"> 10 </p>
                        </div>
                    </div>
                );

                tawWOD = (
                    <div className="TAW-wod">
                        <h3>Word of the day:</h3>
                        <h1>Appreciation</h1>
                        <p>Definition: The thanks, joy, and classroom funding that shall be rained upon teachers
                                    this week by the DonorsChoose community.</p>
                        <h2>{teacherName} is a superstar teacher, and we&apos;re showing our appreciation.</h2>
                    </div>
                );

                tawGAME = (
                    <div className="TAW-game">
                        <h3>DonorsChoose Match 4</h3>
                        <p>Let&apos;s bring a little play to your day. You can complete this game with your students or on your own. Check back each day this week for a new game!
                        </p>
                        <div className="game-grid">
                            <a className="button-primary"
                                href="https://connections.swellgarfo.com/game/-NwHNAAIdhv5x3jqdtLM"
                                target="_blank" rel="noreferrer">Play today&#39;s game</a>
                        </div>
                    </div>
                );
            }

            break;

            // for tuesday 7th, 7am est
        case 7:

            tawCalendar = (
                <div className="calendarContainer">
                    <div className="calendar done">
                        <p className="day"> Monday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/>  </p>
                    </div>
                    <div className="calendar">
                        <p className="day"> Tuesday </p>
                        <p className="number"> 7 </p>
                    </div>
                    <div className="calendar not-today">
                        <p className="day"> Wednesday </p>
                        <p className="number"> 8 </p>
                    </div>
                    <div className="calendar not-today">
                        <p className="day"> Thursday </p>
                        <p className="number"> 9 </p>
                    </div>
                    <div className="calendar not-today">
                        <p className="day"> Friday </p>
                        <p className="number"> 10 </p>
                    </div>
                </div>
            );

            tawWOD = (
                <div className="TAW-wod">
                    <h3>Word of the day:</h3>
                    <h1>Celebrate</h1>
                    <p>Definition: To throw a massive party for {teacherName} and their colleagues.</p>
                    <h2>Teachers are heroes and deserve a virtual parade. Let&apos;s celebrate!</h2>
                </div>
            );

            tawGAME = (
                <div className="TAW-game">
                    <h3>DonorsChoose Match 4</h3>
                    <p>Let&apos;s bring a little play to your day. You can complete this game with your students or on your own. Check back each day this week for a new game!</p>
                    <div className="game-grid">
                        <a className="button-primary" href="https://connections.swellgarfo.com/game/-NwHNKygMNLdJLhYlcD6" target="_blank" rel="noreferrer">Play today&#39;s game</a>
                    </div>
                </div>
            );

            break;

            // for wednesday 8th, 7am est
        case 8:
            tawCalendar = (
                <div className="calendarContainer">
                    <div className="calendar done">
                        <p className="day"> Monday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar done">
                        <p className="day"> Tuesday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar">
                        <p className="day"> Wednesday </p>
                        <p className="number"> 8 </p>
                    </div>
                    <div className="calendar not-today">
                        <p className="day"> Thursday </p>
                        <p className="number"> 9 </p>
                    </div>
                    <div className="calendar not-today">
                        <p className="day"> Friday </p>
                        <p className="number"> 10 </p>
                    </div>
                </div>
            );

            tawWOD = (
                <div className="TAW-wod">
                    <h3>Word of the day:</h3>
                    <h1>Perseverance</h1>
                    <p>Definition: The invisible cape worn by amazing teachers when they face challenges, overcome obstacles, and strive ahead with their students.</p>
                    <h2>In the best of times and worst of times, {teacherName}&apos;{teacherName.charAt(teacherName.length - 1) !== 's' ? 's' : ''} perseverance shined bright this year.</h2>
                </div>
            );

            tawGAME = (
                <div className="TAW-game">
                    <h3>DonorsChoose Match 4</h3>
                    <p>Let&apos;s bring a little play to your day. You can complete this game with your students or on your own. Check back each day this week for a new game!</p>
                    <div className="game-grid">
                        <a className="button-primary" href="https://connections.swellgarfo.com/game/-NwHP-aiTXPE3FcQJSFx" target="_blank" rel="noreferrer">Play today&#39;s game</a>
                    </div>
                </div>
            );

            break;

            // for thursday 9th, 7am est
        case 9:

            tawCalendar = (
                <div className="calendarContainer">
                    <div className="calendar done">
                        <p className="day"> Monday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar done">
                        <p className="day"> Tuesday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar done">
                        <p className="day"> Wednesday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar">
                        <p className="day"> Thursday </p>
                        <p className="number"> 9 </p>
                    </div>
                    <div className="calendar not-today">
                        <p className="day"> Friday </p>
                        <p className="number"> 10 </p>
                    </div>
                </div>
            );

            tawWOD = (
                <div className="TAW-wod">
                    <h3>Word of the day:</h3>
                    <h1>Creative</h1>
                    <p>Definition: The most underrated quality of great teachers.</p>
                    <h2>Whether tackling curriculum challenges, reaching a struggling student, or bringing lesson plans to life, {teacherName} is a creative powerhouse.</h2>
                </div>
            );

            tawGAME = (
                <div className="TAW-game">
                    <h3>DonorsChoose Match 4</h3>
                    <p>Let&apos;s bring a little play to your day. You can complete this game with your students or on your own. Check back each day this week for a new game!</p>
                    <div className="game-grid">
                        <a className="button-primary" href="https://connections.swellgarfo.com/game/-NwHNV_MYbtHaj0n6fuF" target="_blank" rel="noreferrer">Play today&#39;s game</a>
                    </div>
                </div>
            );

            break;

            // for friday 10th, 7am est
        case 10:

            tawCalendar = (
                <div className="calendarContainer">
                    <div className="calendar done">
                        <p className="day"> Monday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar done">
                        <p className="day"> Tuesday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar done">
                        <p className="day"> Wednesday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar done">
                        <p className="day"> Thursday </p>
                        <p className="number"> <Svg icon="check" attributes={{ role: 'presentation' }}/> </p>
                    </div>
                    <div className="calendar">
                        <p className="day"> Friday </p>
                        <p className="number"> 10 </p>
                    </div>
                </div>
            );

            tawWOD = (
                <div className="TAW-wod">
                    <h3>Word of the day:</h3>
                    <h1>Gratitude</h1>
                    <p>Definition: Thanks for a call answered and a job well done.</p>
                    <h2>Our deepest gratitude, {teacherName}, for everything you&apos;ve done for your students.</h2>
                </div>
            );

            tawGAME = (
                <div className="TAW-game">
                    <h3>DonorsChoose Match 4</h3>
                    <p>Let&apos;s bring a little play to your day. You can complete this game with your students or on your own. Check back each day this week for a new game!</p>
                    <div className="game-grid">
                        <a className="button-primary" href="https://connections.swellgarfo.com/game/-NwHOCOyYzwEGz9GGhv2" target="_blank" rel="noreferrer">Play today&#39;s game</a>
                    </div>
                </div>
            );

            break;

        default:
            tawContent = null;
            break;
        }

        // making sure that it only shows for 2024
        if (currentYear === 2024) {
            return (
                <section className="TAWcontainer">
                    <div className="TAWcalendar">
                        {tawCalendar}
                    </div>
                    <div className="TAWcopy">
                        {tawHeader}
                    </div>
                    <div className="TAWcontent">
                        {tawContent}
                        {tawSubHeader}
                        {tawSubCopy}
                        {tawWOD}
                        {tawGAME}
                        {tawSubheaderInterim}
                    </div>
                </section>
            );
        }

        return null;
    }

    return (
        renderTAWContent()
    );
}

TeacherStatsBanner.propTypes = {
    isTeacher: PropTypes.bool.isRequired,
    teacherName: PropTypes.string,
};

export default TeacherStatsBanner;
